import * as React from 'react';
import { ListingState, BaseRouteProps } from '../../interfaces';
import { Language } from '../../models';
import { LanguageDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { DataGrid, PVAPage } from '../../components';

export class LanguageListing extends React.Component<BaseRouteProps<{}>, ListingState<Language>> {
    private languageDataService = new LanguageDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{}>) {
        super(props);

        this.state = {
            entities: new Array<Language>(),
        };
    }

    public componentDidMount() {
        this.languageDataService.getAll().then((languages: Language[]) => {
            this.setState(
                { entities: languages }
            );
        });
    }

    public render() {
        const listData = this.state.entities.map(entity => {
            return {
                'Name': entity.name,
                'Code': entity.code,
                'ActionKey': entity.id
            };
        });

        const actionsColumn = ({ value }: any) => {
            return (
                <span>
                    <NavLink to={`/language/${value}`} className="btn btn-default">View</NavLink>
                </span>
            );
        };

        const columnDefs = [
            { id: 'Name' },
            { id: 'Code' },
            { id: 'ActionKey', title: 'Actions', width: '88px', customComponent: actionsColumn, sortable: false }
        ];

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        Languages
                    </PVAPage.Header.Title>
                    <PVAPage.Header.Buttons>
                        <NavLink className="btn btn-primary" to={'/language/create'}>
                            <span className="glyphicon glyphicon-plus" /> Create
                        </NavLink>
                    </PVAPage.Header.Buttons>
                </PVAPage.Header>

                <PVAPage.Body>
                    <DataGrid entities={listData} columns={columnDefs} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }
}


// WEBPACK FOOTER //
// ./src/components/language/LanguageListing.tsx